import rtkQueryHooks from '../impl/rtk-redux.hook.js'
import { createCachedGraph } from './graph.hook.js'

const cachedGraph = createCachedGraph(rtkQueryHooks)

export { cachedGraph as graphHooks }
export { useIsEntityAccessDenied } from './use-is-entity-access-denied.js'
export { useConflictKeepalive, useConflictResolutionKey, useEntityConflict } from './use-entity-conflict.js'
export type { EntityUpdateFn } from '../graph-types.js'
